<template>
  <el-checkbox-button
    v-bind="trimAttrs($attrs)"
  >
    <slot />
  </el-checkbox-button>
</template>

<script>
import { CheckboxButton } from 'element-ui';
export default {
  name: 'JskCheckboxButton',
  components: {
    ElCheckboxButton: CheckboxButton
  },
  methods: {
    trimAttrs: function(attrs) {
      Object.keys(attrs).forEach((key) => {
        let prefixes = ['is-', 'has-', 'checkbox-button-'];
        prefixes.forEach((prefix) => {
          if (key.substr(0, prefix.length) === prefix) {
            attrs[key.substr(prefix.length)] = attrs[key];
          }
        })
      })
      return attrs;
    }
  }
}
</script>
<style lang="scss" src="../../theme/checkbox-button.scss"></style>
